import "./CustomInput.scss";
import { TextField, TextFieldVariants } from "@mui/material";

interface CustomInputProps {
  label: string;
  name: string;
  id: string;
  variant: TextFieldVariants;
  className?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (e: React.FocusEvent<HTMLInputElement>) => void;
  defaultValue?: string;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  value?: string;
}
const CustomInput = ({
  id,
  label,
  variant,
  className,
  name,
  onChange,
  onFocus,
  defaultValue,
  onBlur,
  value
}: CustomInputProps) => {
  return (
    <TextField
      id={id}
      label={label}
      variant={variant}
      className={className}
      name={name}
      onChange={onChange}
      onFocus={onFocus}
      autoComplete="off"
      defaultValue={defaultValue}
      onBlur={onBlur}
      value={value}
      inputProps={{ maxLength: 255 }}
    />
  );
};

export default CustomInput;
